import { StatusBadge } from "@/components/StatusBadge";
import dayjs from "dayjs";
import React from "react";

export const copyToClipboard = (text) => {
  if (navigator?.clipboard?.writeText) {
    navigator.clipboard.writeText(text).catch(() => {
      fallbackCopy(text);
    });
  } else {
    fallbackCopy(text);
  }
};

const fallbackCopy = (text) => {
  try {
    const el = document.createElement("textarea");
    el.value = text;
    el.setAttribute("readonly", "");
    el.style.position = "absolute";
    el.style.left = "-9999px";
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
  } catch (err) {
    console.error("Kopyalama başarısız:", err);
  }
};
import { isAuth } from "./auth";
import toast from "react-hot-toast";
import CowIcon from "@/components/icons/CowIcon";
import {
  Flame,
  UtensilsCrossed,
  Droplets,
  Sprout,
  Heart,
  HeartHandshake,
  BookOpen,
  HandCoins,
  HeartPulse,
  Building2,
  Award,
  LayoutDashboard,
  Home,
  Settings,
  Users,
  Wallet,
  FileCheck2,
  ShieldCheck,
  SquareKanban,
  FileVideo,
  TrendingUp,
  GraduationCap,
  FolderKanban,
  Layers,
} from "lucide-react";

export const normalizeCopyValue = (value) => {
  if (Array.isArray(value)) {
    const firstString = value.find((item) => typeof item === "string");
    if (firstString) return firstString;

    const firstObject = value.find((item) => item && typeof item === "object");
    if (firstObject) return normalizeCopyValue(firstObject);

    return "";
  }

  if (value && typeof value === "object") {
    return (
      value.link ??
      value.media_link ??
      value.url ??
      value.href ??
      value.dosya_full_path ??
      value.path ??
      value.file_path ??
      value.filePath ??
      value.src ??
      ""
    );
  }

  return value == null ? "" : String(value);
};

export const getPrettyLinkLabel = (value) => {
  const normalizedValue = normalizeCopyValue(value);
  if (!normalizedValue) return "Link";

  const cleanedValue = normalizedValue.replace(/\\/g, "/");
  const lastSegment = cleanedValue.split("/").filter(Boolean).pop() || "";

  if (!lastSegment) return "Link";

  try {
    return decodeURIComponent(lastSegment);
  } catch (_) {
    return lastSegment;
  }
};

export function ColorBox({ deger, onClickFunction, dataActions }) {
  if (dataActions && dataActions[deger]) {
    const action = dataActions[deger];
    return (
      <StatusBadge
        color={action.color}
        onClick={(e) => {
          if (
            onClickFunction &&
            action.authorization.includes(isAuth().rol)
          ) {
            onClickFunction(e);
          } else {
            toastCreater("Yetkiniz Bulunmamaktadır!", "e");
          }
        }}
      >
        {action.text}
      </StatusBadge>
    );
  } else {
    return <span className="text-xs text-slate-600">{deger}</span>;
  }
}

//eski
// export function ColorBox({ deger, onClickFunction, dataActions }) {
//   if (dataActions[deger]) {
//     return (
//       <span
//         className={" noselect badgee bg-" + dataActions[deger].color}
//         onClick={
//           onClickFunction
//             ? dataActions[deger].authorization.find(
//                 (data) => data === isAuth().rol
//               )
//               ? onClickFunction
//               : null
//             : null
//         }
//       >
//         {dataActions[deger].text}
//       </span>
//     );
//   } else {
//     return <span>{deger}</span>;
//   }
// }

export const DataAbbreviation = (data) => {
  if (data) {
    if (data.length > 20) {
      return data.substring(0, 16) + "...";
    } else {
      return data;
    }
  } else {
    return "";
  }
};

export const OnClickCopyLink = (link, setFunction, deger) => (e) => {
  e.preventDefault();
  copyToClipboard(normalizeCopyValue(link));
  if (deger === true) {
    setFunction(true);
    setTimeout(() => setFunction(false), 2000); // 2 saniye sonra geri değiştir
  } else {
    setFunction(deger);
    setTimeout(() => setFunction(-1), 2000); // 2 saniye sonra geri değiştir
  }
};

export const OnClickCopyText = (text, setIcon, index) => (e) => {
  e.preventDefault();
  const upperCaseText = String(text || "").toLocaleUpperCase("tr-TR");
  copyToClipboard(upperCaseText);
  setIcon(index);
  setTimeout(() => setIcon(-1), 2000); // 2 saniye sonra ikonu geri değiştir
};

export const DateFormater = (date) => {
  if (date) {
    return <>{dayjs(date).format("DD.MM.YYYY HH:mm:ss")}</>;
  }
  return "";
};

export const toastCreater = (text, type) => {
  switch (type) {
    case "s":
      toast.success(text, { autoClose: 2000 });
      break;
    // case "i":
    //   toast.info(text, { autoClose: 2000 });
    //   break;
    // case "w":
    //   toast.warn(text, { autoClose: 2000 });
    //   break;
    case "e":
      toast.error(text, { autoClose: 2000 });
      break;

    default:
      toast.success(text, { autoClose: 2000 });
      break;
  }
};

export const iconCreater = (iconName) => {
  if (!iconName) {
    return <FolderKanban className="size-4 shrink-0" />;
  }

  const normalized = String(iconName)
    .trim()
    .toLowerCase()
    .replace(/ç/g, "c")
    .replace(/ğ/g, "g")
    .replace(/ı/g, "i")
    .replace(/ö/g, "o")
    .replace(/ş/g, "s")
    .replace(/ü/g, "u")
    .replace(/[^a-z0-9]/g, " ");

  if (
    normalized.includes("kurban") ||
    normalized.includes("adak") ||
    normalized.includes("vacip")
  ) {
    return <CowIcon className="size-4 shrink-0" />;
  }
  if (
    normalized.includes("iftar") ||
    normalized.includes("sahur") ||
    normalized.includes("yemek") ||
    normalized.includes("kumanya") ||
    normalized.includes("corba")
  ) {
    return <UtensilsCrossed className="size-4 shrink-0" />;
  }
  if (normalized.includes("su") || normalized.includes("kuyu")) {
    return <Droplets className="size-4 shrink-0" />;
  }
  if (normalized.includes("fidan") || normalized.includes("agac")) {
    return <Sprout className="size-4 shrink-0" />;
  }
  if (
    normalized.includes("sosyal") ||
    normalized.includes("toplum") ||
    normalized.includes("dayanisma")
  ) {
    return <HeartHandshake className="size-4 shrink-0" />;
  }
  if (
    normalized.includes("yetim") ||
    normalized.includes("kirve")
  ) {
    return <Heart className="size-4 shrink-0" />;
  }
  if (
    normalized.includes("hafiz") ||
    normalized.includes("hatim") ||
    normalized.includes("kuran")
  ) {
    return <BookOpen className="size-4 shrink-0" />;
  }
  if (
    normalized.includes("zekat") ||
    normalized.includes("bagis") ||
    normalized.includes("kumbara")
  ) {
    return <HandCoins className="size-4 shrink-0" />;
  }
  if (
    normalized.includes("acil") ||
    normalized.includes("yardim") ||
    normalized.includes("insani")
  ) {
    return <HeartPulse className="size-4 shrink-0" />;
  }
  if (
    normalized.includes("eser") ||
    normalized.includes("bina") ||
    normalized.includes("cami") ||
    normalized.includes("toplu")
  ) {
    return <Building2 className="size-4 shrink-0" />;
  }
  if (normalized.includes("sponsor") || normalized.includes("madalya")) {
    return <Award className="size-4 shrink-0" />;
  }
  if (normalized.includes("dashboard")) {
    return <LayoutDashboard className="size-4 shrink-0" />;
  }
  if (normalized.includes("ana sayfa") || normalized.includes("home")) {
    return <Home className="size-4 shrink-0" />;
  }
  if (normalized.includes("ayar")) {
    return <Settings className="size-4 shrink-0" />;
  }
  if (normalized.includes("bagisci") || normalized.includes("kullanici")) {
    return <Users className="size-4 shrink-0" />;
  }
  if (
    normalized.includes("mali") ||
    normalized.includes("kasa") ||
    normalized.includes("banka") ||
    normalized.includes("tahsilat")
  ) {
    return <Wallet className="size-4 shrink-0" />;
  }
  if (normalized.includes("mutabakat")) {
    return <FileCheck2 className="size-4 shrink-0" />;
  }
  if (normalized.includes("proje yonetimi")) {
    return <SquareKanban className="size-4 shrink-0" />;
  }
  // 2026-10-09: menüdeki Video Yükleme (projeId/ortak) için ikon — önceden boştu
  if (normalized.includes("video yukleme")) {
    return <FileVideo className="size-4 shrink-0" />;
  }
  if (normalized.includes("yonetim") || normalized.includes("admin")) {
    return <ShieldCheck className="size-4 shrink-0" />;
  }
  if (normalized.includes("performans") || normalized.includes("istatistik")) {
    return <TrendingUp className="size-4 shrink-0" />;
  }
  if (
    normalized.includes("talebe") ||
    normalized.includes("ogrenci") ||
    normalized.includes("burs")
  ) {
    return <GraduationCap className="size-4 shrink-0" />;
  }
  if (normalized.includes("diger")) {
    return <Layers className="size-4 shrink-0" />;
  }

  // Varsayılan: Asla boş ikon dönmez
  return <FolderKanban className="size-4 shrink-0" />;
};
export const dovizIsaret = (isaretName) => {
  switch (isaretName) {
    case "TRY":
      return "₺";
    case "USD":
      return "$";
    case "EUR":
      return "€";
    case "GBP":
      return "£";
    default:
      return " ";
  }
};
export const turkce_karaktersiz_eslestirme = (aranacak_text, aranan_text) => {
  try {
    if (aranacak_text) {
      let letters = {
        İ: "i",
        I: "i",
        Ş: "s",
        Ğ: "g",
        Ü: "u",
        Ö: "o",
        Ç: "c",
        ı: "i",
        ş: "s",
        ğ: "g",
        ü: "u",
        ö: "o",
        ç: "c",
      };
      aranacak_text = aranacak_text.replace(
        /(([İIŞĞÜÖÇışğüöç]))/g,
        function (letter) {
          return letters[letter];
        }
      );
      aranan_text = aranan_text.replace(
        /(([İIŞĞÜÖÇışğüöç]))/g,
        function (letter) {
          return letters[letter];
        }
      );
      if (
        aranacak_text.toLowerCase().includes(aranan_text.toLowerCase()) === true
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  } catch (err) {
    console.log(err);
    return false;
  }
};
const filterText = (text) =>
  text.replace(/<br>/g, "").replace(/\s|&nbsp;/g, "");

export const calculateRtlDirection = (text) => {
  const filteredText = filterText(text);
  const totalChars = filteredText.length;
  const rtlChars = (
    filteredText.match(/[\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC]/g) || []
  ).length;
  return totalChars > 0 && rtlChars / totalChars > 0.5 ? "rtl" : "ltr";
};

export const customColors = [
  "#008FFB",
  "#33FF57",
  "#3357FF",
  "#FF33A1",
  "#A133FF",
  "#33FFA1",
  "#FF8C33",
  "#8C33FF",
  "#33FFF6",
  "#FF3333",
  "#FF33FF",
  "#33FF8C",
  "#33D4FF",
  "#D4FF33",
  "#8CFF33",
  "#FF5733",
  "#A1FF33",
  "#33FFA1",
  "#57FF33",
  "#FF3357",
];
